import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { Tripbook } from '../domain/entities/Tripbook.ts'
import { CreateTripbookUseCase } from '../domain/useCases/tripbooks/CreateTripbookUseCase.ts'
import { GetTripbooksUseCase } from '../domain/useCases/tripbooks/GetTripbooksUseCase.ts'
import { UpdateTripbookUseCase } from '../domain/useCases/tripbooks/UpdateTripbookUseCase.ts'
import { AuthenticationRepository } from '../repositories/AuthenticationRepository.ts'
import { TripbookRepository } from '../repositories/TripbookRepository.ts'

const tripbookRepository = new TripbookRepository(new AuthenticationRepository())
const getTripbooksUseCase = new GetTripbooksUseCase(tripbookRepository)
const createTripbookUseCase = new CreateTripbookUseCase(tripbookRepository)
const updateTripbookUseCase = new UpdateTripbookUseCase(tripbookRepository)

export const TRIPBOOKS_QUERY_KEY = 'tripbooks' as const

export function useTripbooks(agencyId?: string, userEmail?: string, keyword?: string) {
    const queryClient = useQueryClient()

    const tripbooksQuery = useQuery({
        queryKey: [TRIPBOOKS_QUERY_KEY, agencyId, keyword],
        queryFn: () => {
            if(agencyId === undefined && !keyword && (userEmail === "soporte@51trips.com") ){
                return []
            }
            return getTripbooksUseCase.execute(agencyId, keyword)
        },
        enabled: !!userEmail
    })

    const createTripbookMutation = useMutation({
        mutationFn: (data: Tripbook) => createTripbookUseCase.execute(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [TRIPBOOKS_QUERY_KEY] })
        },
    })

    const updateTripbookMutation = useMutation({
        mutationFn: (data: Tripbook) => updateTripbookUseCase.execute(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [TRIPBOOKS_QUERY_KEY] })
        },
    })

    return {
        tripbooks: tripbooksQuery.data,
        isLoadingTripbooks: tripbooksQuery.isLoading,
        tripbooksError: tripbooksQuery.error,
        refetchTripbooks: tripbooksQuery.refetch,
        createTripbook: createTripbookMutation.mutateAsync,
        isCreatingTripbook: createTripbookMutation.isPending,
        updateTripbook: updateTripbookMutation.mutateAsync,
        isUpdatingTripbook: updateTripbookMutation.isPending,
    }
}
